// extracted by mini-css-extract-plugin
export default {"container":"OverView_container__v9+md","cards":"OverView_cards__TC2HY","section2":"OverView_section2__worTw","section3":"OverView_section3__AIxBG"};